exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-single-container[data-v-9906e376] {\n  width: 100vw;\n  display: flex;\n  flex-flow: column;\n}\n.product-single-container .product-wrapper[data-v-9906e376] {\n  padding: 0 13px;\n}", ""]);

// exports
